// extracted by mini-css-extract-plugin
export default {"body":"CountModalButton_body__GWQQh"};